import { render, staticRenderFns } from "./InputSigarusText.vue?vue&type=template&id=4905b28f"
import script from "./InputSigarusText.vue?vue&type=script&lang=js"
export * from "./InputSigarusText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports